import React from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    titleTypograph: {
        textAlign: 'center',
        marginBottom: theme.spacing(4)
    }
}));

export default function Title() {
    const classes = useStyles();

    return (
        <Typography
            variant="h4"
            component="h1"
            color='primary'
            gutterBottom
            className={classes.titleTypograph}>
            Validar Diploma/Histórico de Graduação
        </Typography>
    );
};